export const camelize = (val: string) =>
  val.replace(/-./g, (match) => match.toUpperCase()[1]);
